import { annexesConstants as annexes } from "../../../constants/annexes";

const initialState = { loading: true, list: [], annexe: null };

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case annexes.GET_ANNEXES:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case annexes.GET_ANNEXE:
      return {
        ...state,
        loading: false,
        annexe: payload,
      };
    default:
      return state;
  }
}
